enum WorkType {
    ONSITE = 1,
    REMOTE = 2,
}


export const WorkTypeLabel: Record<WorkType, string> = {
    [WorkType.ONSITE]: "Onsite",
    [WorkType.REMOTE]: "Remote",
};

export const WorkTypeOptions = Object.values(WorkType)
    .filter(v => typeof v === "number")
    .map(v => ({
        id: v,
        name: WorkTypeLabel[v as WorkType]
    }));

export type TUserRecord = {
    id?: number;
    name: string;
    email: string;
    password: string;
    workFrom: WorkType;
    branchId: number;
    status: boolean;
    phoneNo?: string;
    dateOfJoining?: Date | string;
    roles: number[];
}

export const EmptyUser: TUserRecord = {
    name: '',
    email: '',
    password: '',
    workFrom: WorkType.ONSITE,
    branchId: 0,
    status: true,
    roles: [],
}

export type TUser = {
    id: number;
    name: string;
    email: string;
    password: string;
    workFrom: WorkType;
    companyId: number;
    companyName: string;
    branchId: number;
    branchName: string;
    status: boolean;
    phoneNo?: string;
    dateOfJoining?: Date;
}

export interface TUserFilter {
    branchId: number | null,
    roleId: number | null,
    status: boolean | null,
    workFrom: WorkType | null,
}

export const EmptyUserFilter: TUserFilter = {
    branchId: null,
    roleId: null,
    status: null,
    workFrom: null,
};